var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticStyle:{"text-align":"center"}},[_c('QRCode',{attrs:{"URL":_vm.salseQRCode,"QRCodeWidth":250}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_vm._v("\n              邀請你的親朋好友用手機拍攝QR Code，EGL名單輕鬆入手！\n          ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e4a8188","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mobile/SalseQRCodePage.vue
// module id = null
// module chunks = 